import {
  GetClaimShare,
  GetClaimShareVariables,
} from "_graphql/queries/__generated__/GetClaimShare";
import {
  GetClaimShares,
  GetClaimSharesVariables,
} from "_graphql/queries/__generated__/GetClaimShares";
import {
  GetKEKClaimShare,
  GetKEKClaimShareVariables,
} from "_graphql/kek/queries/__generated__/GetKEKClaimShare";
import {
  GetKEKClaimShares,
  GetKEKClaimSharesVariables,
} from "_graphql/kek/queries/__generated__/GetKEKClaimShares";
import {
  GetOfferClaimParticipantPayments,
  GetOfferClaimParticipantPaymentsVariables,
} from "_graphql/queries/__generated__/GetOfferClaimParticipantPayments";
import {
  GetOfferClaims,
  GetOfferClaimsVariables,
} from "_graphql/queries/__generated__/GetOfferClaims";
import {
  getKEKOfferClaimShare,
  getKEKOfferClaimShares,
} from "_graphql/kek/queries/offers.kek";
import {
  getOfferClaimParticipantPayments,
  getOfferClaimShare,
  getOfferClaimShares,
  getOfferClaims,
} from "_graphql/visal/queries/offers";

import { useQuery } from "@apollo/client";

export const useOfferClaims = (variables?: GetOfferClaimsVariables) => {
  const { data, ...rest } = useQuery<GetOfferClaims, GetOfferClaimsVariables>(
    getOfferClaims,
    {
      variables,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: "network-only",
    }
  );

  const claims = data?.getOfferClaims || [];

  return { claims, count: claims.length, ...rest };
};

// TODO: replace with the proper queries and types from KEK
export const useKEKOfferClaims = (variables?: GetOfferClaimsVariables) => {
  const { data, ...rest } = useQuery<GetOfferClaims, GetOfferClaimsVariables>(
    getOfferClaims,
    {
      variables,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: "network-only",
    }
  );

  const claims = data?.getOfferClaims || [];

  return { claims, count: claims.length, ...rest };
};

export const useOfferClaimShares = (variables?: GetClaimSharesVariables) => {
  const { data, ...rest } = useQuery<GetClaimShares, GetClaimSharesVariables>(
    getOfferClaimShares,
    {
      variables,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: "network-only",
    }
  );

  const shares = data?.getClaimShares || [];

  return { shares, count: shares.length, ...rest };
};

export const useKEKOfferClaimShares = (
  variables?: GetKEKClaimSharesVariables
) => {
  const { data, ...rest } = useQuery<
    GetKEKClaimShares,
    GetKEKClaimSharesVariables
  >(getKEKOfferClaimShares, {
    variables,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });

  const shares = data?.getClaimShares || [];

  return { shares, count: shares.length, ...rest };
};

export const useOfferClaimShare = (variables?: GetClaimShareVariables) => {
  const { data, ...rest } = useQuery<GetClaimShare, GetClaimShareVariables>(
    getOfferClaimShare,
    {
      variables,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: "network-only",
    }
  );

  const share = data?.getClaimShare;

  return { share, ...rest };
};

export const useKEKOfferClaimShare = (
  variables?: GetKEKClaimShareVariables
) => {
  const { data, ...rest } = useQuery<
    GetKEKClaimShare,
    GetKEKClaimShareVariables
  >(getKEKOfferClaimShare, {
    variables,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });

  const share = data?.getClaimShare;

  return { share, ...rest };
};

export const useOfferClaimSharePayments = (
  variables: GetOfferClaimParticipantPaymentsVariables
) => {
  const { data, ...rest } = useQuery<
    GetOfferClaimParticipantPayments,
    GetOfferClaimParticipantPaymentsVariables
  >(getOfferClaimParticipantPayments, {
    variables,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });

  const payments = data?.getOfferClaimParticipantPayments || [];

  return { payments, ...rest };
};
